<template>
  <div id="app" ref="frame" class="frame" :style="getFrameStyle">
    <div
      :style="{
        position: 'relative',
        top: '0px',
        zIndex: '1',
        height: this.getScreenHeight + 'px'
      }"
      v-show="this.selectedProjectIndex == -1"
    >

      <div v-for="(_project, index) in this.getConformedProjects" :key="index" :style="{position:'relative'}">
        <ProjectSquare
          :pSize="getSquareSize(_project.tSizeSquare)"
          :pIndex="index"
          :pLocation="arrLocations[index]"
          :pAtEnd="arrEnds[index]"
          :pProject="_project"
          :pSelectedProjectIndex="-1"
          :tick="squareTick"
          :key="index"
          :boxSize="boxSize"
          :gridMargin="gridMargin"
          :pSizeSquare="_project.tSizeSquare"
        />
      </div>

      <div
        :style="{
          height: '40px',
          position: 'relative',
        }"
      ></div>

      <div
        :style="{
          width: '100vw',
          height: '100vh',
          backgroundColor: '#000000cc',
          position: 'absolute',
          top: '0px',
          bottom: '0px',
          zIndex: '900'
        }"
        v-show='this.isSlideshow'
        >
          <Slideshow />
      </div>
    </div>

    <div class="projectPreviewFrame" v-if="this.selectedProjectIndex != -1">
      <ProjectSquare
        :pSize="getSquareSize(1)"
        :pIndex="this.selectedProjectIndex"
        :pProject="this.getConformedProjects[this.selectedProjectIndex]"
        :pSelectedProjectIndex="selectedProjectIndex"
      />
    </div>
  </div>
</template>

<script>
import ProjectSquare from "@/components/ProjectSquare.vue";
import Slideshow from "@/components/Slideshow.vue";

import StrapiService from "@/services/StrapiService.js";

import gsap from "gsap";
import { ScrollToPlugin } from "gsap/all";
import { EventBus } from "@/event-bus.js";

//import { vueVimeoPlayer } from "vue-vimeo-player";

gsap.registerPlugin(ScrollToPlugin);

const IS_LOCAL = true

export default {
  name: "App",
  components: {
    ProjectSquare, Slideshow
  },
  props: ['projectName'],
  methods: {

    checkDevice() {
      const userAgent = navigator.userAgent || navigator.vendor;
      
      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        this.isMobile = true;
      }
      else if (/android/i.test(userAgent)) {
        this.isMobile = true;
      }
      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.isMobile = true;
      }
      else {
        this.isMobile = false;
      }
    },
  
    getProjectFromName(_name) {
      for (var i=0; i<this.arrProjects.length; i++) {

        var _str = this.arrProjects[i].title.replace(/\s+/g, '-').toLowerCase();
        console.log(_str + " | " + _name)
        if (_name == _str) {
          return i
        }
      }
      return -1
    },

    filterProjects: function (_f) {

      for (var _i = 0; _i < this.arrProjects.length; _i++) {

        this.arrProjects[_i].tSizeSquare = this.isGrid ? this.mobileSquareSize : this.arrProjects[_i].sizeSquare;
        this.arrProjects[_i].show = false;

        if (_f == 1 || _f == 2) {
          if (
            (_f == 1 && this.arrProjects[_i].isSoftware) ||
            (_f == 2 && this.arrProjects[_i].isHardware)
          ) {
            this.arrProjects[_i].show = true;
          }
        } else if (_f == 3) {

          if (this.arrProjects[_i].isFeatured) {
            this.arrProjects[_i].show = true;
          }

        } else if (!this.arrProjects[_i].isDisabled) {
          this.arrProjects[_i].show = true;
        }
      }
    },
    handleScroll: function (e) {
      console.log(e);
      //EventBus.$emit("is-scroll", true);
    },
    resizeHandler: function (e) {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.initGrid(false);

        console.log("> " + e);
      }, 100);
    },
    getSquareSize: function (_size) {
      if (!_size) {
        _size = 1;
      }
      return _size * this.boxSize + (_size - 1) * this.gridMargin;
    },
    getMainCategory: function (_p) {
      var _cat = "";
      if (_p.madsci_primary_category) {
        _cat = _p.madsci_primary_category.title;
      }
      console.log(">>" + _cat);
      return _cat;
    },
    isVisible: function (_index, _project) {
      var _visible = true;

      //If we have selected an event
      if (
        this.selectedProjectIndex != _index &&
        this.selectedProjectIndex != -1
      ) {
        _visible = false;
      }

      //Check category Filters
      if (
        (this.categoryFilterIndex != -1 &&
          this.arrCategoryFilterNames[this.categoryFilterIndex] !=
            this.getMainCategory(_project)) ||
        (this.categoryFilterIndex == -1 && _project.isNotFeatured == true)
      ) {
        _visible = false;
      }

      return _visible;
    },
    backToTop: function () {},

    setAvailArray(_type) {

      var _arrObj = [];

      for (var w = 0; w <= this.gridCols - _type; w++) {
        for (var h = 0; h <= this.gridRows - _type; h++) {
          if (this.checkUsedArray(w, h, _type, 0)) {
            //checkUsedArray(w, h, _type,1);
            var _index = h * this.gridCols + w;

            _arrObj.push(_index);
          }
        }
      }
      return _arrObj;
    },
    checkUsedArray(_x, _y, _type, _set) {

      for (var w = 0; w < _type; w++) {
        for (var h = 0; h < _type; h++) {
          if (_set == 1) {
            this.arrUsed[_x + w][_y + h] = true;
          } else {
            if (this.arrUsed[_x + w][_y + h] == true) {
              return false;
            }
          }
        }
      }
      return true;
    },

    resetUsedArray() {
      this.arrUsed = [];
      for (var c = 0; c < this.gridCols; c++) {
        this.arrUsed[c] = [];
        for (var r = 0; r < this.gridRows; r++) {
          this.arrUsed[c][r] = false;
        }
      }
    },

    getRandomInt(_max) {
      return Math.floor(Math.random() * Math.floor(_max));
    },

    drawMobileSet(arrIndex, _type, _cols) {
      var _num = arrIndex.length;
      //console.log("Draw Set : " + _num + ", " + _type);

      for (var i = 0; i < _num; i++) {
        //this.arrAvail[_type] = this.setAvailArray(_type);


        //v is the index number of the box in the array of boxes we get the row and column of it
        var _col = (i % _cols) * 3; 
        var _row = Math.floor(i / _cols) * _type;

        var _x = _col * (this.gridMargin + this.boxSize) + this.gridMargin;
        var _y = _row * (this.gridMargin + this.boxSize) + this.gridMargin;

        //Set locations
        this.$set(this.arrLocations, arrIndex[i], [_x, _y]);
        this.$set(this.arrEnds, arrIndex[i], [(_row == this.gridCols -1 ? true : false), (_col == this.gridRows - 1? true : false)]);

        //Set used array
        //this.checkUsedArray(_row, _col, _type, 1);

      }
    },

    drawSet(arrIndex, _type) {
      var _num = arrIndex.length;
      //console.log("Draw Set : " + _num + ", " + _type);

      for (var i = 0; i < _num; i++) {
        this.arrAvail[_type] = this.setAvailArray(_type);

        //console.log("Avail " + _type + " " + this.arrAvail[_type]);
        var _ran = this.getRandomInt(this.arrAvail[_type].length);
        var v = this.arrAvail[_type].splice(_ran, 1);

        //v is the index number of the box in the array of boxes we get the row and column of it
        var _col = Math.floor(v / this.gridCols);
        var _row = v % this.gridCols;

        var _x = _row * (this.gridMargin + this.boxSize) + this.gridMargin;
        var _y = _col * (this.gridMargin + this.boxSize) + this.gridMargin;

        //Set locations
        this.$set(this.arrLocations, arrIndex[i], [_x, _y]);

        //console.log("SET X " + _col + " " + this.gridCols)
        //console.log("SET Y " + _row + " " + this.gridRows)

        this.$set(this.arrEnds, arrIndex[i], [(_row == this.gridCols -1 ? true : false), (_col == this.gridRows - 1? true : false)]);

        //Set used array
        this.checkUsedArray(_row, _col, _type, 1);

      }
    },
    initGrid(_firstTime, _f, _minBoxes=this.minBoxes) {

      var _arr = this.getConformedProjects;

      if (_firstTime || _f > 0) {
        this.arrContentIndexArrayBySize[1] = [];
        this.arrContentIndexArrayBySize[2] = [];
        this.arrContentIndexArrayBySize[3] = [];
        for (var _i = 0; _i < _arr.length; _i++) {
          var _s = _arr[_i].tSizeSquare;
          if (!_s) {
            _s = 1;
          }

          this.arrContentIndexArrayBySize[_s].push(_i);
        }
      }

      var _width = window.innerWidth;
      var _height = window.innerHeight;

      if (this.isGrid) {

        this.gridCols = this.mobileSquareSize * this.getGridColumns
        this.gridRows = _arr.length * this.mobileSquareSize / this.getGridColumns

      } else {

        //Get number of cols, rows based on ratio of widht/height of window
        var _r = _height / _width;
        var _n = Math.ceil(Math.sqrt(_minBoxes / _r));

        this.gridCols = _n;
        this.gridRows = Math.floor(_r * _n);
      }

      //Calculate boxSize
      this.boxSize = Math.floor(
        _width /
          (this.marginPercent * this.gridCols +
            this.marginPercent +
            this.gridCols)
      );

      this.gridMargin = Math.floor(this.marginPercent * this.boxSize);
      console.log("* GRID MARGIN : " + this.gridMargin);

      this.gridWidth =
        this.gridCols * (this.gridMargin + this.boxSize) + this.gridMargin;
      this.gridHeight =
        this.gridRows * (this.gridMargin + this.boxSize) + this.gridMargin;

      this.arrAvail = [];
      this.resetUsedArray();

      if (this.isGrid) {
        this.drawMobileSet(this.arrContentIndexArrayBySize[this.mobileSquareSize], this.mobileSquareSize, this.getGridColumns);
      } else {
        this.drawSet(this.arrContentIndexArrayBySize[3], 3);
        this.drawSet(this.arrContentIndexArrayBySize[2], 2);
        this.drawSet(this.arrContentIndexArrayBySize[1], 1);
      }
    },
  },
  computed: {

    getGridColumns: function() {
      return this.isMobile ? 1 : this.forceNumColumns
    },

    getEmptyColumnStyle: function() {

      return {
        position: 'relative',
        height:'200px',
        width: '200px',
        border: 'solid 1px #ff0000'
      }
    },

    isGrid: function () {

      return this.isFilterGrid || this.isMobile
    },

    getSlideshowStyle: function () {

      return {
        left: this.boxSize + 1.5*this.gridMargin + 'px',
        top: this.boxSize + 1.5*this.gridMargin + 'px',
        width: (this.gridCols - 2) * (this.boxSize + this.gridMargin) + 'px',
        height: (this.gridRows - 2) * (this.boxSize + this.gridMargin) + 'px',
        backgroundColor: '#ffffff',
        position: 'absolute',
        boxShadow: '3px 3px 10px'
      }
    },

    getConformedProjects: function () {

      console.log(this.tFilter)
      let _arr = []
      for (var _i = 0; _i < this.arrProjects.length; _i++) {

        if (this.arrProjects[_i].show || this.arrProjects[_i].projectType == 2) {
          _arr.push(this.arrProjects[_i])
        }
      }

      return _arr

    },
    getFrameStyle: function () {
      //console.log("000 >>>" + window.innerHeight);
      //console.log("000 >>>" + window.innerWidth);

      if (this.isGrid)
      {
        return {
          height: '100vh',
          width: '100vw',
          overflow: "scroll",
          position: "relative",
        };
      }
      else
      {
        return {
          overflow: (this.isGrid ? "scroll" : "hidden"),
          position: "relative",
        };
      }

    },
    getScreenHeight: function () {
      //let _l = (1.25 + this.gridRows) * this.boxSize;
      //console.log("size : " + _l)

      let _h = (1.25 + this.gridRows) * this.boxSize
      console.log("* page size : " + this.boxSize + " " + _h)
      return Math.floor(_h); //_val;
    },
    /*getProjectHeight: function () {
      return window.innerWidth * 0.21;
    },
    getProjectWidth: function () {
      return 0.7 * window.innerWidth;
    },*/
  },
  created() {
    this.mapLocation = new Map();
    this.checkDevice();
    //this.mapLocation.set(0, 4)

    this.windowHeight = window.innerHeight;
    EventBus.$on("filter", (_f) => {

      if (_f == 4) {

        this.isFilterGrid = !this.isFilterGrid
        _f = 0
      }

      /*else if (this.isFilterGrid) {
        this.isFilterGrid = false
      }*/

      console.log(_f);
      this.tFilter = _f;

      //filter projects
      this.filterProjects(this.tFilter);

      //Init grid
      this.initGrid(true, _f);

    }),
      EventBus.$on("close-project", (_out) => {
        console.log(_out);
        console.log("CLOSE CLOSE CLOSE ");
        this.selectedProjectIndex = -1;
      }),
      EventBus.$on("select-project", (_i) => {
        this.closeCount = 0;
        if (this.selectedProjectIndex == _i) {
          this.selectedProjectIndex = -1;
        } else {
          this.selectedProjectIndex = _i;
        }
        this.headerOpen = true;

        //this.backToTop();

        console.log("** SELECTED PROJECT : " + this.selectedProjectIndex);
      }),
      StrapiService.getAdamLassyProjects(IS_LOCAL).then((response) => {

        //StrapiService.getProjects().then((response) => {
        console.log("GET CONFORMED");
        console.log(response.data);
        this.arrProjects = response.data;

        this.filterProjects(0);
        this.initGrid(true);

        //If event passed in
        if (this.$route.name == 'madsci-project') {

          this.closeCount = 0;
          this.headerOpen = true;

          this.selectedProjectIndex = this.getProjectFromName(this.projectName)
          console.log("*** project : " + this.projectName + " " + this.selectedProjectIndex)
        }

      });
  },
  mounted() {
    window.addEventListener("resize", this.resizeHandler);
    this.videoPlayer = document.getElementById(this.getVideoID);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
    clearTimeout(this.resizeTimer);
  },
  data() {
    return {
      closeCount: 0,
      initHeader: false,
      headerOpen: true,
      windowHeight: 0,
      count: 0,
      arrProjects: [],
      selectedProjectIndex: -1,
      categoryFilterIndex: -1,
      nameFilter: "",
      arrCategoryFilterNames: [
        "Projects & Events",
        "Agency Work",
        "Research & Experiments",
      ],
      minBoxes: 170,
      arrContentLengthBySize: [-1, 0, 0, 0, 0],
      arrContentIndexArrayBySize: [[], [], [], [], []],

      gridCols: 0,
      gridRows: 0,

      marginPercent: 0.1,
      gridMargin: 0,

      arrUsed: [],
      arrAvail: [],
      boxSize: 0,

      arrLocations: [],
      arrEnds:[],

      locationIndexes: 0,
      mapLocation: new Map(),
      resizeTimer: null,

      tick: 0,
      squareTick: 0,

      tFilter: 0,
      isSlideshow: false,

      videoPlayer: Object,

      isMobile: false,
      isFilterGrid: true,
      forceNumColumns: 3,
      mobileSquareSize: 3

    };
  },
};
</script>

<style>
html {
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */
  -khtml-user-select: none; /* Konqueror */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently*/
  background: "#ffe1e1";

}

.slide-up-move {
  transition: transform 0.25s ease-in;
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: opacity 0.25s;
}
.slide-up-enter, .slide-up-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

h1 {
  line-height: 1.2;
}

#app {
  font-family: "Oswald", sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.list-complete-move {
  transition: transform 0.5s ease-in;
}
.list-complete-item {
  transition: all 1s;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(30px);
}
.list-complete-leave-active {
  position: absolute;
}

.slide-up-move {
  transition: transform 0.5s ease-in;
}
.slide-up-enter-active,
.slide-up-leave-active {
  transition: opacity 0.5s;
}
.slide-up-enter, .slide-up-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.frame {
  overflow: scroll;
  text-align: center;
  color: #414141;

  margin: 0 auto;
  padding-top: 0px;
  padding-bottom: 0px;
  position: relative;
}
body {
  font-family: "Oswald", sans-serif;

  margin: 0px;
  padding: 0px;

  height: 100%;

  font-size: 16px;
  line-height: 1.1;

  overflow: hidden;
  background: #fcfcfc;
}

.projectPreviewFrame {
  position: relative;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  color: #111111;
}

a {
  color: #414141;
  font-weight: 700;
  background-color: transparent;
  text-decoration: none;

  font-size: 12px;
  line-height: 1.1;
}

a:hover {
  opacity: 1;
  text-decoration: underline;
}
</style>
